'use client'

import { FC } from 'react'
import { useTranslations } from 'next-intl'
import { Icons } from '@/app/components/ui/Icons'
import '@/app/styles/components/BlogEmptyState.css'

const BlogEmptyState: FC = () => {
	const t = useTranslations('Blog')

	return (
		<div className="blog-empty-state">
			<div className="blog-empty-state__icon-container">
				<Icons.blogEmptyState className="blog-empty-state__icon" />
			</div>
			<h2 className="blog-empty-state__title">{t('emptyState.title')}</h2>
			<div className="blog-empty-state__description">
				<p className="blog-empty-state__description-line">
					{t('emptyState.descriptionLine1')}
				</p>
				<p className="blog-empty-state__description-line">
					{t('emptyState.descriptionLine2')}
				</p>
			</div>
		</div>
	)
}

export default BlogEmptyState

